import React, { forwardRef, useState } from 'react';
import BalancesSection from './BalancesSection';
import { EBalancesTheme, HeaderProps } from './types';
import { createGradientOrSolid } from '../../Helper/utils/utils';
import { StyledHeader } from './style';
import DailyBonusBadge from '../../Popups/DailyBonusBadge';

const Header = forwardRef(
  (
    {
      profilePicUrl,
      profilePicBorder = { colorOne: 'white' },
      playerName = '',
      openLogoutModal,
      overrideStore,
      logoPicUrl,
      balances = undefined,
      balanceQuantityFormat,
      preview = false,
      showHeader,
      balanceTheme = EBalancesTheme.DEFAULT,
      profileFrameImg = '',
      backgroundColor,
      fullWidth,
      playerLevelImg,
      fontFamily,
      dailyBonusBadges,
      timer,
      onClickBadge,
    }: HeaderProps,
    ref,
  ) => {
    const [picLoaded, setPicLoaded] = useState(false);
    const isProfileInfo = balances?.length !== 0 || !!playerName;
    return (
      <StyledHeader
        visibility={showHeader ? 'unset' : 'hidden'}
        isProfileInfo={isProfileInfo}
        playerName={playerName}
        backgroundColor={backgroundColor ?? 'transparent'}
        fullWidth={fullWidth}
        balanceTheme={balanceTheme}
        hasBadge={dailyBonusBadges && dailyBonusBadges.length > 0}
        className={balanceTheme}
      >
        <div data-hide="true" className="profileContainer">
          <div
            className="frame"
            style={{
              background: !profileFrameImg
                ? balanceTheme === EBalancesTheme.SPACEGO
                  ? 'white'
                  : createGradientOrSolid(profilePicBorder)
                : 'none',
              border:
                balanceTheme === EBalancesTheme.SPACEGO
                  ? '3px solid #FFFFFF'
                  : 'none',
            }}
          >
            {profileFrameImg && (
              <img
                className="profileContainer__profileFrame"
                src={profileFrameImg}
                alt="profile-frame"
                onClick={openLogoutModal}
              />
            )}
            <img
              alt="profile"
              className="profileContainer__img"
              src={profilePicUrl}
              onClick={openLogoutModal}
              style={{ display: picLoaded ? 'unset' : 'none' }}
              onLoad={() => setPicLoaded(true)}
            />
            <img
              alt="profile"
              className="profileContainer__img"
              onClick={openLogoutModal}
              src="https://media.appcharge.com/defaults/old-profile.png"
              style={{ display: picLoaded ? 'none' : 'unset' }}
            />
          </div>
          {isProfileInfo && (
            <div
              className={`profileContainer-info ${
                balanceTheme === EBalancesTheme.BAGELCODE
                  ? 'bagelCodeInfoContainer'
                  : ''
              }`}
            >
              {playerName && <span className="playerName">{playerName}</span>}
              {balances && balances?.length > 0 && balanceTheme && (
                <BalancesSection
                  balances={balances}
                  balanceTheme={balanceTheme}
                  balanceQuantityFormat={balanceQuantityFormat}
                  playerLevelImg={playerLevelImg}
                />
              )}
            </div>
          )}
        </div>
        <div
          data-hide="true"
          className={`logo ${!isProfileInfo ? 'defaultInfoLogo' : ''}`}
          style={{
            display:
              balanceTheme === EBalancesTheme.BAGELCODE ||
              balanceTheme === EBalancesTheme.PLAY_SIMPLE ||
              balanceTheme === EBalancesTheme.ME2ON ||
              balanceTheme === EBalancesTheme.PIPA
                ? 'none'
                : 'flex',
          }}
        >
          <img
            alt="logo"
            className="logo__main"
            onClick={(e) => {
              if (
                process.env.NODE_ENV === 'development' &&
                e.detail === 3 &&
                !preview
              ) {
                overrideStore();
              }
            }}
            src={logoPicUrl}
          />
        </div>
        {dailyBonusBadges && dailyBonusBadges.length > 0 && (
          <div className="badgesContainer">
            {dailyBonusBadges.map((badge) => (
              <DailyBonusBadge
                key={badge?.offerId}
                title="Daily Bonus"
                titleSize="12px"
                badgeCoverImage={badge?.badgeCoverImage}
                borderColor={badge?.borderColor || { colorOne: '#ffffff' }}
                borderWidth="2px"
                timer={timer}
                font={fontFamily || 'Open Sans'}
                onClickBadge={onClickBadge}
                offerId={badge.offerId}
              ></DailyBonusBadge>
            ))}
          </div>
        )}
      </StyledHeader>
    );
  },
);

export default Header;
